// Vendors
import React from 'react';
import moment from 'moment';

// Components
import { Trans } from '../../../components/common';
import ServiceIcon from '../../../components/common/ServiceIcon/ServiceIcon';
import SummaryCard from '../../../components/common/Cards/SummaryCard/SummaryCard';

// PRJ1417943_IntergrationAccelerator - Separated from UnlinkServiceModal for reusability and agency-specific Props: account, agency, ... (add more as needed)
const DPSSummaryCard = ({ account, agency }) => {
  const summaryList =
    account.licenseType === 'DL' || account.licenseType === 'CDL'
      ? [
          {
            label: <Trans file="Labels" id="Name" fallback="Name" />,
            value: `${account.personalInformation.firstName
              ? account.personalInformation.firstName
              : ''
              }
              ${account.personalInformation.middleName
                ? account.personalInformation.middleName
                : ''
              }
            ${account.personalInformation.lastName
                ? account.personalInformation.lastName
                : ''
              }
              ${account.personalInformation.suffix
                ? account.personalInformation.suffix
                : ''
              }`,
          },
          {
            label: <Trans file="Labels" id="Class" fallback="Class" />,
            value: account.licenseClass,
          },
          {
            label: <Trans file="Labels" id="Expiration" fallback="Expiration" />,
            value: moment(account.expirationDate).format('MM/DD/YYYY'),
          },
        ]
      : [
          {
            label: <Trans file="Labels" id="Name" fallback="Name" />,
            value: `${account.personalInformation.firstName}
              ${account.personalInformation.middleName
                ? account.personalInformation.middleName
                : ''
              }
            ${account.personalInformation.lastName}
              ${account.personalInformation.suffix
                ? account.personalInformation.suffix
                : ''
              }`,
          },
          {
            label: (
              <Trans
                file="Labels"
                id="Expiration_Date"
                fallback="Expiration_Date"
              />
            ),
            value: moment(account.expirationDate).format('MM/DD/YYYY'),
          },
        ];

  return (
    <SummaryCard
      key={account.vin}
      className="card-flat"
      outlined={false}
    >
      <div className="flex-item">
        <div className="flex-row-wrap">
          <div className="flex-item license-plate-icon">
            <ServiceIcon
              className="agency-linked-services-item-icon-text flex-item"
              type={`driver-license`}
            />
            <div className="flex-item service-icon text">
              {account.licenseType === 'DL' ||
              account.licenseType === 'CDL' ? (
                <Trans
                  file={agency.agencySlug}
                  id={`${agency.agencySlug}_Driver_License`}
                />
              ) : (
                <Trans
                  file={agency.agencySlug}
                  id={`${agency.agencySlug}_ID_Card`}
                />
              )}
            </div>
          </div>
          <div className="flex-item vehicle-details">
            <SummaryCard.List items={summaryList} />
          </div>
        </div>
      </div>
    </SummaryCard>
  );
};

export default DPSSummaryCard;
